<template>
<div class="notice-list" :class="pageType">
    <div class="list">
        <div class="notice-item" v-for="item,index in data" :key="index" @click="readMessageHandle(item)">
            <div class="read">
                <span class="yes" v-if="item.isRead">已读</span>
                <span class="no" v-else>未读</span>
            </div>
            <div class="notice-content">
                <div class="notice-item-title">{{ item.messageTitle }}</div>
                <div class="notice-item-content">
                    <span>{{ item.messageContent }}</span>
                    <span>{{ item.createAt }}</span>
                </div>
            </div>
        </div>
    </div>
    <div class="pagination">
        <a-pagination
            :current="pagination.page"
            :pageSize="pagination.size"
            :total="pagination.total"
            :size="pageType === 'page' ? 'normal' : 'small'"
            :showTotal="total => `共 ${total} 条`"
            @change="pageChangeHandle"/>
    </div>
</div>
</template>

<script>
import { getRoute } from './config'

export default {
    props: {
        data: {
            type: Array,
            default: () => ([])
        },
        pageType: String,
        pagination: {
            type: Object,
            default: () => ({
                page: 1,
                size: 10,
                total: 10
            })
        }
    },
    data() {
        return {}
    },
    computed: {
        currentUser () {
            return this.$store.state.account.user
        }
    },
    methods: {
        readMessageHandle (item) {
            if (item.isRead) {
                this._goPage(item)
                return
            }
            this.$axios.post(this.$apis.UPDATE_MESSSAGE_INFO, { messageId: item.messageId }).then(res => {
                let { success } = res 
                if (success) {
                    item.isRead = 1
                    this._goPage(item)
                    this.$emit('readSuccess')
                }
            })
        },
        _goPage (item) {
            getRoute(item, this.currentUser).then(routerPath => {
                routerPath && this.$router.push({ path: routerPath })
                this.$eventBus.$emit('noticeLayerShow', false)
            })
        },
        pageChangeHandle (page) {
            this.$emit('pageChange', page)
        }
    },
    mounted () {
      
    }
}
</script>

<style lang="less">
.notice-list {
    display: flex;
    flex-direction: column;
    height: 100%;
    &.layer {
        max-height: 300px;
        overflow: auto;
    }
    .list {
        flex: 1
    }
    .notice-item {
        display: flex;
        padding: 8px 20px;
        line-height: 1.6;
        cursor: pointer;
        transition: all .2s;
        &:hover {
            background: #e6f7ff;
        }
        .read {
            flex: 0 0 40px;
            .yes {
                color: #999;
            }
            .no {
                color: #1890ff;
            }
        }
        .notice-content {
            flex: 1;
            .notice-item-content {
                font-size: 12px;
                color: #999;
                margin-top: 5px;
            }
        }
    }
    .pagination {
        padding: 0 20px;
        text-align: right;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/notice/notice-list.vue